















import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";
import ReportNumber from "@/components/Pages/Report/Atoms/ReportNumber/index.vue";
import ReportPreviousTime from "@/components/Pages/Report/Atoms/ReportPreviousTime/index.vue";
import Stars from "@/components/Molecules/Rates/Stars/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReportNumberField",
  components: {
    ReportNumber,
    ReportPreviousTime,
    Stars
  },
  props: {
    reportNumberBody: {
      type: Number,
      required: true
    },
    reportPreviousTimeIconName: {
      type: String,
      required: true
    },
    reportPreviousTimeBody: {
      type: Number,
      required: true
    },
    starValue: {
      type: Number,
      default: 0
    }
  }
});
